import { ApolloClient } from '@apollo/client'

export const logout = async (client: ApolloClient<unknown>) => {
  await client.clearStore()
  localStorage.clear()
}
